document.addEventListener('turbolinks:load', function () {
  $('.personalize_slideup_btn').on('click', function () {
    $.when($(this).parent().parent().children('.personalize_slide_flag').slideUp()).done($(this).fadeOut(0), $(this).parent().children('.personalize_slidedown_btn').fadeIn(0));
  });

  $('.personalize_slidedown_btn').on('click', function () {
    $.when($(this).parent().parent().children('.personalize_slide_flag').slideDown()).done($(this).fadeOut(0), $(this).parent().children('.personalize_slideup_btn').fadeIn(0));
  });

  // ------------------------------------------------------------------------------------------------
  // パーソナライズ設定管理
  // ------------------------------------------------------------------------------------------------
  
  // #################################################################
  // パーソナライズ設定名の編集
  // #################################################################
  $('#personalize_name_edit_btn').on('click', function () {
    let personalize_id = $('.personalize_select_box option:selected').val();
    let name = $('.personalize_name_val').val();

    if (!name) {
      alert('名称を記入して下さい。');
      return;
    }

    $.ajax({
      url: '/save_personalize_name',
      type: 'POST',
      data: {
        personalize_id: personalize_id,
        name: name
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // パーソナライズ設定名の編集
  // #################################################################
  $('#personalize_description_edit_btn').on('click', function () {
    let personalize_id = $('.personalize_select_box option:selected').val();
    let description = $('.personalize_description_val').val();

    $.ajax({
      url: '/save_personalize_description',
      type: 'POST',
      data: {
        personalize_id: personalize_id,
        description: description
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // クッキー名の編集
  // #################################################################
  $('#personalize_cookie_name_edit_btn').on('click', function () {
    let personalize_id = $('.personalize_select_box option:selected').val();
    let cookie_name = $('.personalize_cookie_name_val').val();

    $.ajax({
      url: '/save_personalize_cookie_name',
      type: 'POST',
      data: {
        personalize_id: personalize_id,
        cookie_name: cookie_name
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // ローカルストレージのkeyの編集
  // #################################################################
  $('#personalize_local_storage_key_edit_btn').on('click', function () {
    let personalize_id = $('.personalize_select_box option:selected').val();
    let local_storage_key = $('.personalize_local_storage_key_val').val();

    $.ajax({
      url: '/save_personalize_local_storage_key',
      type: 'POST',
      data: {
        personalize_id: personalize_id,
        local_storage_key: local_storage_key
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // URL設定
  // #################################################################
  $('#personalize_url_add_input').on('click', function () {
    if ($('.personalize_url_input').length >= 20) {
      return;
    }
    $(this)
      .parents('table')
      .append(
        `<tr>
            <th></th>
            <td class="h-50px py-0 text-left ">
              <input class="personalize_url_input w-390px h-30px py-0 px-3 border-b dark:border-none" type="text">
            </td>
            <td class="h-50px py-0 px-6 text-left ">
              <div class="personalize_url_del text-2xl cursor-pointer text-gray-400 dark:text-gray-600">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15" />
                </svg>
              </div>
            </td>
          </tr>`
      );
    $('.personalize_url_del').on('click', function () {
      $(this).parent().parent('tr').remove();
    });
  });
  $('.personalize_url_del').on('click', function () {
    $(this).parent().parent('tr').remove();
  });

  $('#personalize_url_set').on('click', function () {
    let personalize_id = $('.personalize_select_box option:selected').val();
    let urls = [];
    $('.personalize_url_input').each(function () {
      urls.push($(this).val().trim());
    });

    $.ajax({
      url: '/set_personalize_url',
      type: 'POST',
      data: {
        personalize_id: personalize_id,
        urls: urls,
      },
      dataType: 'json',
    }).done(function (data) {
      location.reload();
    });
  });

  // #################################################################
  // URL判定条件
  // #################################################################
  $('.personalize_url_condition_flag_select').on('change', function () {
    let personalize_id = $('.personalize_select_box option:selected').val();
    let url_condition_flag = $('.personalize_url_condition_flag_select').val();

    $.ajax({
      url: '/save_personalize_url_condition_flag',
      type: 'POST',
      data: {
        personalize_id: personalize_id,
        url_condition_flag: url_condition_flag
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });
});
